<template>
    <div class="ranking-container" v-wechat-title="'mysread'">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <div class="rankTypeContainer">
            <ul>
                <li @click="rankTypeClick1" :class="{rankTypeClick:activeRankTypeItem === '點擊榜'}">
                    <span>點擊榜</span>
                </li>
                <li @click="rankTypeClick2" :class="{rankTypeClick:activeRankTypeItem === '暢銷榜'}">
                    <span>暢銷榜</span>
                </li>
                <li @click="rankTypeClick3" :class="{rankTypeClick:activeRankTypeItem === '月票榜'}">
                    <span>月票榜</span>
                </li>
                <li @click="rankTypeClick4" :class="{rankTypeClick:activeRankTypeItem === '打賞榜'}">
                    <span>打賞榜</span>
                </li>
                <li @click="rankTypeClick5" :class="{rankTypeClick:activeRankTypeItem === '新書榜'}">
                    <span>新書榜</span>
                </li>
                <li @click="rankTypeClick6" :class="{rankTypeClick:activeRankTypeItem === '更新榜'}">
                    <span>更新榜</span>
                </li>
                <li @click="rankTypeClick7" :class="{rankTypeClick:activeRankTypeItem === '好評榜'}">
                    <span>好評榜</span>
                </li>
                <li @click="rankTypeClick8" :class="{rankTypeClick:activeRankTypeItem === '完結榜'}">
                    <span>完結榜</span>
                </li>
            </ul>
        </div>

        <div class="bookListContainer">
            <ul>
                <li v-for="book in bookList">
                    <div @click="getBookDetail(book.id)">
                        <img :src="book.pic1">
                        <span style="color: black;top: 15%">{{book.title}}</span>
                        <span style="top: 35%;">作者：{{book.author}}</span>
                        <span style="top: 55%;">狀態：{{book.zt}}</span>
                        <span style="top: 75%;">類型：{{book.flmc}}</span>
                    </div>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "RankingVue",

    data() {
        return {
            activeRankTypeItem: "點擊榜",
            bookList: [],
            isCreate: false,
            isRequest: false,
        };
    },

    methods: {
        //點擊榜
        rankTypeClick1: function () {
            this.activeRankTypeItem = "點擊榜";
            this.getRankData("hit");
        },

        //暢銷榜
        rankTypeClick2: function () {
            this.activeRankTypeItem = "暢銷榜";
            this.getRankData("sale");
        },

        //月票榜
        rankTypeClick3: function () {
            this.activeRankTypeItem = "月票榜";
            this.getRankData("ticket");
        },

        //打賞榜
        rankTypeClick4: function () {
            this.activeRankTypeItem = "打賞榜";
            this.getRankData("reward");
        },

        //新書榜
        rankTypeClick5: function () {
            this.activeRankTypeItem = "新書榜";
            this.getRankData("new");
        },

        //更新榜
        rankTypeClick6: function () {
            this.activeRankTypeItem = "更新榜";
            this.getRankData("update");
        },

        //好評榜
        rankTypeClick7: function () {
            this.activeRankTypeItem = "好評榜";
            this.getRankData("favourable");
        },

        //完結榜
        rankTypeClick8: function () {
            this.activeRankTypeItem = "完結榜";
            this.getRankData("finished");
        },

        //獲取榜單數據
        getRankData: function (rankType) {
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getIndexRanking");
            params.append("name", rankType);
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.bookList = res.data.data;
                } else {
                    alert(res.data.msg);
                }
            });
        },

        //獲取書籍詳情
        getBookDetail: function (bookId) {
            this.$router.push({
                path: "BookDetailVue",
                query: {
                    bookId: bookId,
                    vueName: "RankingVue",
                },
            });
        },
    },
    created() {
        this.isCreate = true;
        this.activeRankTypeItem = "點擊榜";
        this.getRankData("hit");
    },

    beforeRouteEnter(to, from, next) {
        to.meta.isBack = from.name === "BookDetail";
        next();
    },

    activated() {
        // 如果isBack是false 、isCreate也為false，表明需要獲取新數據
        if (!this.$route.meta.isBack && !this.isCreate) {
            //防止進入頁面重新獲取數據的時候還是在之前進入頁面的位置
            window.scrollTo(0, -1);
            this.activeRankTypeItem = "點擊榜";
            this.getRankData("hit");
        }
        // 恢復成默認的false，避免isBack壹直是true，導致下次無法獲取數據
        this.$route.meta.isBack = false;
        //重置isCreate為false ,避免isCreate壹直是true，導致下次無法獲取數據
        this.isCreate = false;
    },
};
</script>

<style scoped>
.ranking-container {
    margin-top: 50px;
    display: flex;
    flex-direction: row;
    overflow-y: hidden;
}

.rankTypeContainer {
    height: calc(100vh - 100px);
    width: 25%;
    background-color: whitesmoke;
    float: left;
    overflow-y: hidden;
}

.rankTypeContainer ul {
    width: 100%;
    line-height: 50px;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    text-align: center;
}

.rankTypeContainer ul li {
    list-style: none;
    border-bottom: 1px solid gainsboro;
}

.rankTypeContainer ul li span {
    color: black;
}

.rankTypeClick {
    background-color: white;
}

.bookListContainer {
    width: 75%;
    height: calc(100vh - 100px);
    padding-top: 10px;
    padding-bottom: 40px;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
}

.bookListContainer ul {
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    text-align: left;
}

.bookListContainer ul li {
    list-style: none;
    border-bottom: 1px solid gainsboro;
    height: 100%;
    position: relative;
    padding: 10px;
}

.bookListContainer ul li img {
    width: 30%;
}

.bookListContainer ul li span {
    top: 3%;
    width: 60%;
    position: absolute;
    margin-left: 10px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/RankingVue.vue